
import { Button } from "@/components/ui/button";
import { CheckCircle, Globe, Loader2, ExternalLink } from "lucide-react";
import { ValidationStatus } from "./ValidationStatus";
import { PixelDetails } from "./PixelDetails";
import { EmailTestResult } from "./EmailTestResult";

interface ValidationContentProps {
  validationResult: any;
  websiteCheckResult: any;
  checkingWebsite: boolean;
  isValidating: boolean;
  onCheckWebsite: () => Promise<void>;
  onTestEmailNotification: () => Promise<void>;
}

export function ValidationContent({
  validationResult,
  websiteCheckResult,
  checkingWebsite,
  isValidating,
  onCheckWebsite,
  onTestEmailNotification
}: ValidationContentProps) {
  if (!validationResult) return null;

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center space-x-2">
        <CheckCircle className="h-6 w-6 text-green-500" />
        <h3 className="text-lg font-medium">Pixel Found in Database</h3>
      </div>
      
      <ValidationStatus websiteCheckResult={websiteCheckResult} />
      
      <div className="w-full">
        <Button
          onClick={onCheckWebsite}
          disabled={checkingWebsite}
          className="w-full"
        >
          {checkingWebsite ? (
            <>
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              Checking Website...
            </>
          ) : (
            <>
              <Globe className="w-4 h-4 mr-2" />
              {websiteCheckResult ? "Check Website Again" : "Check Website"}
            </>
          )}
        </Button>
      </div>
      
      <div className="grid gap-4">
        <PixelDetails 
          details={validationResult.details} 
          websiteCheckResult={websiteCheckResult} 
        />
        
        <div className="space-y-4">
          <h4 className="text-sm font-medium">Test Email Notification</h4>
          <EmailTestResult 
            emailTestResult={validationResult.emailTestResult} 
            isValidating={isValidating}
            onTestEmail={onTestEmailNotification}
          />
        </div>
      </div>
    </div>
  );
}
